var watchlistDelete = {
	title: "Supprimer liste",
	nameInputLabel: "Nom liste",
	alertHeading: "Voulez-vous supprimer la liste?",
	alertBody: "Si oui, cliquez sur le bouton \"Supprimer\". Attention: Une liste supprimée ne peut pas être restaurée.",
	confirmBtn: "Supprimer",
	cancelBtn: "Annuler"
};
var fr = {
	watchlistDelete: watchlistDelete
};

export { fr as default, watchlistDelete };
